import axios from 'axios';
import { getSessionId, getTransactionId, logUserAction } from './commonFunctions';

const api = axios.create();

api.interceptors.request.use(config => {
  config.headers['x-session-id'] = getSessionId();
  config.headers['x-transaction-id'] = getTransactionId();
  return config;
});

api.interceptors.response.use(
  response => {
    logUserAction('API_RESPONSE', {
      url: response.config.url,
      status: response.status,
      sessionId: getSessionId(),
      transactionId: response.config.headers['transactionId'],
      // Add custom params: orderId, chefId, etc. if available
    });
    return response;
  },
  error => {
    logUserAction('API_ERROR', {
      url: error.config?.url,
      status: error.response?.status,
      sessionId: getSessionId(),
      transactionId: error.config?.headers['transactionId'],
      // Add custom params
    });
    throw error;
  }
);

export default api; 